import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import Logo from "@/components/Logo";
import { useAuth, homeFor } from "@/context/AuthContext";

const LINKS = [{ to: "/program", label: "Program" }];

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"}`;

function NavLinks({ onClick, vertical }) {
  return (
    <nav className={vertical ? "flex flex-col gap-5" : "hidden md:flex items-center gap-8"}>
      {LINKS.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end} className={linkCls} onClick={onClick} data-testid={`nav-${l.label.toLowerCase()}-link`}>
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}

function AuthButtons() {
  const { user } = useAuth();
  if (user) {
    return (
      <Button asChild className="bg-slate-900 hover:bg-slate-800" data-testid="nav-dashboard-button">
        <Link to={homeFor(user)}>Dashboard</Link>
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-2">
      <Button asChild variant="ghost" data-testid="nav-login-button"><Link to="/login">Masuk</Link></Button>
      <Button asChild className="bg-amber-500 text-slate-900 hover:bg-amber-400" data-testid="nav-register-button"><Link to="/daftar">Daftar Sekarang</Link></Button>
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200" data-testid="public-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <NavLinks />
        <div className="hidden md:block"><AuthButtons /></div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" data-testid="mobile-menu-button"><Menu className="h-5 w-5" /></Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetTitle className="mb-8"><Logo /></SheetTitle>
            <NavLinks vertical onClick={() => setOpen(false)} />
            <div className="mt-8" onClick={() => setOpen(false)}><AuthButtons /></div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
